var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_260_992",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7647 40H3.23529C1.44849 40 0 38.7208 0 37.1429V2.85714C0 1.27919 1.44849 0 3.23529 0H25L40 13.2468V37.1429C40 38.7208 38.5515 40 36.7647 40Z",
    fill: "url(#paint0_linear_260_992)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_260_992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7647 40H3.23529C1.44849 40 0 38.7208 0 37.1429V2.85714C0 1.27919 1.44849 0 3.23529 0H25L40 13.2468V37.1429C40 38.7208 38.5515 40 36.7647 40Z",
    fill: "url(#paint1_linear_260_992)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_260_992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 13.2468H38.2468C30.9308 13.2468 25 7.31598 25 0L40 13.2468Z",
    fill: "url(#paint2_linear_260_992)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.67125 31.3333V21.1515H11.4894C12.2716 21.1515 12.9279 21.2974 13.4582 21.589C13.9918 21.8807 14.3945 22.2817 14.6663 22.7922C14.9414 23.2993 15.0789 23.876 15.0789 24.5223C15.0789 25.1752 14.9414 25.7552 14.6663 26.2623C14.3912 26.7694 13.9852 27.1688 13.4482 27.4605C12.9113 27.7488 12.2501 27.893 11.4646 27.893H8.93404V26.3767H11.216C11.6734 26.3767 12.0479 26.2971 12.3396 26.138C12.6312 25.9789 12.8467 25.7602 12.9859 25.4818C13.1284 25.2034 13.1997 24.8835 13.1997 24.5223C13.1997 24.161 13.1284 23.8428 12.9859 23.5677C12.8467 23.2926 12.6296 23.0788 12.3346 22.9264C12.0429 22.7706 11.6668 22.6927 11.2061 22.6927H9.51571V31.3333H7.67125ZM20.1313 31.3333H16.681V21.1515H20.2009C21.2118 21.1515 22.0802 21.3554 22.806 21.763C23.5352 22.1674 24.0953 22.7491 24.4864 23.5081C24.8775 24.2671 25.0731 25.1752 25.0731 26.2325C25.0731 27.2931 24.8759 28.2046 24.4814 28.9669C24.0903 29.7292 23.5252 30.3142 22.7861 30.7218C22.0503 31.1295 21.1654 31.3333 20.1313 31.3333ZM18.5255 29.7375H20.0418C20.7511 29.7375 21.3427 29.6082 21.8167 29.3497C22.2906 29.0878 22.6469 28.6984 22.8856 28.1814C23.1242 27.661 23.2435 27.0114 23.2435 26.2325C23.2435 25.4536 23.1242 24.8073 22.8856 24.2936C22.6469 23.7765 22.2939 23.3904 21.8266 23.1352C21.3626 22.8767 20.7859 22.7474 20.0965 22.7474H18.5255V29.7375ZM26.8256 31.3333V21.1515H33.3483V22.6977H28.67V25.4619H32.9008V27.0081H28.67V31.3333H26.8256Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_260_992",
    x: 2,
    y: -24,
    width: 65,
    height: 63.2468,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_260_992"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_260_992",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_260_992",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_260_992",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85567"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_260_992",
    x1: 32.5,
    y1: 0,
    x2: 32.5,
    y2: 13.2468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D03954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C02A3C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.4ff2b52780d81577b1a30c738f1de02c.svg";
export { ForwardRef as ReactComponent };